import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getSettings, setBaseCurrency, getReviewers } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

const AppContext = createContext(null);

export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const { user: authUser } = useAuth();
  const [theme, setTheme] = useState(() => localStorage.getItem("d20-theme-v2") || "light");
  const [users, setUsers] = useState([]);
  const [baseCurrency, setBase] = useState(() => localStorage.getItem("d20-base-currency") || "GBP");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("d20-theme-v2", theme);
  }, [theme]);

  const updateBaseCurrency = useCallback((c) => {
    setBaseCurrency(c);
    localStorage.setItem("d20-base-currency", c);
    setBase(c);
  }, []);

  useEffect(() => { setBaseCurrency(baseCurrency); }, [baseCurrency]);

  const uid = authUser?.id;
  useEffect(() => {
    if (!uid) return;
    getSettings().then((s) => s?.base_currency && updateBaseCurrency(s.base_currency)).catch(() => {});
    getReviewers().then(setUsers).catch(() => {});
  }, [uid, updateBaseCurrency]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const user = authUser?.name || "";
  const refreshUsers = () => getReviewers().then(setUsers).catch(() => {});

  return (
    <AppContext.Provider value={{ theme, toggleTheme, user, setUser: () => {}, users, refreshUsers, baseCurrency, updateBaseCurrency, isAdmin: authUser?.role === "admin", authUser }}>
      {children}
    </AppContext.Provider>
  );
};
